(function () {
  if (window.__etrustedProductCardRatingInit) return;

  window.__etrustedProductCardRatingInit = true;

  var MOBILE_MEDIA = '(max-width: 699px)';
  var WIDGET_SELECTOR = '.etrusted-product-card-rating etrusted-widget';

  var OUTER_SHADOW_CSS = [
    '@media screen and (max-width: 699px) {',
    '  :host {',
    '    display: block !important;',
    '    width: 100% !important;',
    '    max-width: 100% !important;',
    '    min-width: 0 !important;',
    '    box-sizing: border-box !important;',
    '  }',
    '  etrusted-product-star-widget {',
    '    display: block !important;',
    '    width: 100% !important;',
    '    max-width: 100% !important;',
    '    min-width: 0 !important;',
    '    box-sizing: border-box !important;',
    '  }',
    '}'
  ].join('\n');

  var INNER_SHADOW_CSS = [
    '@media screen and (max-width: 699px) {',
    '  :host {',
    '    display: block !important;',
    '    width: 100% !important;',
    '    max-width: 100% !important;',
    '    min-width: 0 !important;',
    '    box-sizing: border-box !important;',
    '  }',
    '  .product-star-widget {',
    '    width: 100% !important;',
    '    max-width: 100% !important;',
    '    min-width: 0 !important;',
    '    box-sizing: border-box !important;',
    '  }',
    '  .product-star-widget .wrapper {',
    '    display: inline-flex !important;',
    '    flex-wrap: wrap !important;',
    '    align-items: center !important;',
    '    width: 100% !important;',
    '    max-width: 100% !important;',
    '    min-width: 0 !important;',
    '    box-sizing: border-box !important;',
    '    row-gap: 2px !important;',
    '    justify-content: flex-start !important;',
    '  }',
    '  .product-star-widget .wrapper .grade,',
    '  .product-star-widget .wrapper .count {',
    '    font-size: 0.85em !important;',
    '    white-space: normal !important;',
    '  }',
    '}'
  ].join('\n');

  if (!window.__etrustedProductCardShadowPatch) {
    window.__etrustedProductCardShadowPatch = true;

    var previousAttachShadow = Element.prototype.attachShadow;

    Element.prototype.attachShadow = function (init) {
      var options = init ? Object.assign({}, init) : { mode: 'open' };

      if (
        this.tagName === 'ETRUSTED-WIDGET' &&
        this.closest('.etrusted-product-card-rating') &&
        options.mode === 'closed'
      ) {
        options.mode = 'open';
      }

      return previousAttachShadow.call(this, options);
    };
  }

  function injectShadowStyle(shadowRoot, css, marker) {
    if (!shadowRoot || shadowRoot.querySelector('[data-etrusted-card-styles="' + marker + '"]')) return;

    var style = document.createElement('style');
    style.setAttribute('data-etrusted-card-styles', marker);
    style.textContent = css;
    shadowRoot.appendChild(style);
  }

  function applyWidgetStyles(host) {
    if (!host || !host.closest('.etrusted-product-card-rating')) return;

    if (!window.matchMedia(MOBILE_MEDIA).matches) return;

    if (!host.shadowRoot) return;

    injectShadowStyle(host.shadowRoot, OUTER_SHADOW_CSS, 'outer-mobile');

    var innerWidget = host.shadowRoot.querySelector('etrusted-product-star-widget');

    if (innerWidget && innerWidget.shadowRoot) {
      injectShadowStyle(innerWidget.shadowRoot, INNER_SHADOW_CSS, 'inner-mobile');
    }
  }

  function applyAll() {
    document.querySelectorAll(WIDGET_SELECTOR).forEach(applyWidgetStyles);
  }

  function observeWidgets() {
    applyAll();

    [250, 750, 1500, 3000].forEach(function (delay) {
      window.setTimeout(applyAll, delay);
    });

    if ('MutationObserver' in window) {
      var observer = new MutationObserver(applyAll);
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }

    if ('ResizeObserver' in window) {
      var resizeObserver = new ResizeObserver(applyAll);
      document.querySelectorAll('.etrusted-product-card-rating').forEach(function (node) {
        resizeObserver.observe(node);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeWidgets);
  } else {
    observeWidgets();
  }
}());
